import { Link } from 'react-router-dom';

const services = [
  {
    id: 1,
    label: 'Consulting',
    title: 'コンサルティング',
    desc: '経営戦略から業務改善まで、貴社の課題に寄り添った最適解を提案。データに基づく意思決定をサポートします。',
    img: 'https://readdy.ai/api/search-image?query=business%20strategy%20consulting%20professional%20meeting%20whiteboard%20data%20charts%20modern%20office%20clean%20minimal%20Japanese%20corporate%20warm%20tones&width=600&height=400&seq=svc-1&orientation=landscape',
    tag: 'メイン事業',
  },
  {
    id: 2,
    label: 'Advertising',
    title: '広告・プロモーション',
    desc: 'デジタル・アナログを横断した統合マーケティングで、ブランド認知と売上向上を実現します。',
    img: 'https://readdy.ai/api/search-image?query=creative%20advertising%20agency%20campaign%20design%20marketing%20visual%20media%20modern%20minimal%20clean%20workspace%20warm%20neutral&width=600&height=400&seq=svc-2&orientation=landscape',
    tag: 'メイン事業',
  },
  {
    id: 3,
    label: 'Space Design',
    title: '店舗・空間デザイン',
    desc: '顧客体験を高める空間づくり。コンセプト設計から施工監理まで、ワンストップで対応します。',
    img: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20store%20interior%20design%20Japanese%20retail%20space%20warm%20lighting%20wood%20texture%20clean%20elegant%20commercial&width=600&height=400&seq=svc-3&orientation=landscape',
    tag: '',
  },
  {
    id: 4,
    label: 'HR Development',
    title: '人材育成',
    desc: '研修・コーチング・組織開発を通じて、チームの潜在能力を最大限に引き出します。',
    img: 'https://readdy.ai/api/search-image?query=human%20resources%20team%20training%20workshop%20professional%20development%20Japanese%20corporate%20modern%20bright%20collaborative%20workspace&width=600&height=400&seq=svc-4&orientation=landscape',
    tag: '',
  },
];

export default function ServicesOverview() {
  return (
    <section className="w-full bg-[#F5F2ED] py-20 md:py-28">
      <div className="w-full px-6 md:px-16">
        {/* Header */}
        <div className="flex flex-col lg:flex-row justify-between items-start gap-6 mb-14">
          <div>
            <p className="text-xs tracking-[0.3em] text-[#C8501A] uppercase mb-3">Our Services</p>
            <h2 className="text-3xl md:text-4xl font-black text-[#0A0E1A] leading-tight">
              私たちが提供する<br />価値
            </h2>
          </div>
          <div className="max-w-sm">
            <p className="text-sm text-[#6B6560] leading-relaxed">
              4つの事業領域から、クライアントの課題に最適なソリューションを組み合わせてご提供します。
            </p>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 mt-4 text-sm font-medium text-[#0A0E1A] hover:text-[#C8501A] transition-colors cursor-pointer whitespace-nowrap"
            >
              詳細を見る <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s) => (
            <div
              key={s.id}
              className="bg-white rounded-2xl overflow-hidden group cursor-pointer hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                {s.tag && (
                  <span className="inline-block px-2 py-0.5 bg-[#C8501A]/10 text-[#C8501A] text-xs rounded-full mb-2">
                    {s.tag}
                  </span>
                )}
                <p className="text-xs text-[#9C9490] tracking-wider mb-1">{s.label}</p>
                <h3 className="text-base font-bold text-[#0A0E1A] mb-2">{s.title}</h3>
                <p className="text-xs text-[#6B6560] leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
